import {
  TableCellProps,
  BorderProps,
} from 'spindl-shared-components';


type UserRowInternalProps = {
  topBorder?: BorderProps;
  name?: TableCellProps;
  email?: TableCellProps;
  role?: TableCellProps;
  time?: TableCellProps;
  date?: TableCellProps;
  status?: TableCellProps;
  button?: TableCellProps;
};

type UserRowPropsValues = {
  '': UserRowInternalProps;
};

const propValues: UserRowPropsValues = {
  '': {
    topBorder: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    name: {
      type: 'TextPadded',
      state: 'Default',
      size: 'M',
    },
    email: {
      type: 'TextPadded',
      state: 'Default',
      size: 'L',
    },
    role: {
      type: 'Chip',
      state: 'Default',
      size: 'S',
    },
    time: {
      type: 'Text',
      state: 'Default',
      size: 'M',
    },
    date: {
      type: 'Text',
      state: 'Default',
      size: 'M',
    },
    status: {
      type: 'IconText',
      state: 'Activated',
      size: 'M',
    },
    button: {
      type: 'IconDropDown',
      state: 'Default',
      size: 'FullWidth',
    },
  },
};

const getProps = (type: string): UserRowInternalProps => {
  const values: UserRowInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
